export default __webpack_public_path__ + "static/img-finalist-aba-award-20222-37fac54d692a67631379181a2cb0a723.png";